import {
  type Dispatch,
  type ForwardRefRenderFunction,
  forwardRef,
  type SetStateAction,
} from 'react'

import { SwitchStyled } from './styles'

export interface SwitchStyledProps {
  width?: number
  height?: number
  padding?: number | string
  margin?: number | string
  paddingleft?: number | string
  switchsize?: number
  borderradius?: number
  transitionduration?: string
}

export interface ToggleProps {
  value: boolean
  setValue: Dispatch<SetStateAction<boolean | string>>
  processChange: () => void
  disabled?: boolean
  width?: number
  height?: number
  padding?: number | string
  margin?: number | string
  paddingleft?: number | string
  switchsize?: number
  borderradius?: number
  transitionduration?: string
  id?: string
  size?: 'small'
}

const ToggleComponent: ForwardRefRenderFunction<HTMLInputElement, ToggleProps> = (
  {
    value,
    setValue,
    width = 45,
    height = 25,
    padding = 0,
    margin = 2,
    paddingleft = 1,
    switchsize = 20,
    borderradius = 12,
    transitionduration = '200ms',
    processChange,
    disabled = false,
    id,
    size,
  },
  ref,
) => {
  const handleChange = () => {
    setValue(!value)
    processChange()
  }
  return (
    <>
      <SwitchStyled
        borderradius={borderradius}
        checked={value}
        disabled={disabled}
        disableRipple
        focusVisibleClassName=".Mui-focusVisible"
        height={size ? 20 : height}
        id={id}
        inputRef={ref}
        margin={margin}
        onChange={handleChange}
        padding={padding}
        paddingleft={size ? -12 : paddingleft}
        size={size}
        switchsize={switchsize}
        transitionduration={transitionduration}
        value={value}
        width={size ? 30 : width}
      />
    </>
  )
}

export const Toggle = forwardRef(ToggleComponent)
